import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { Formik } from "formik";
import Button from "@material-ui/core/Button";
import Container from "@material-ui/core/Container";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import * as Yup from "yup";
import { withStyles } from "@material-ui/styles";
import Spinner from "../../components/atoms/Spinner";
import { loginUser } from "../../actions";
const styles = theme => ({
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "100%",
    maxWidth: "350px"
  },
  actionsContainer: {
    marginTop: theme.spacing(3)
  },
  error: {
    color: "red"
  }
});

const Login = class extends React.PureComponent {
  render() {
    const { classes, auth, location } = this.props;

    if (auth.isAuthenticated) {
      if (
        location.state &&
        location.state.from &&
        location.state.from.pathname
      ) {
        return <Redirect to={location.state.from.pathname} />;
      } else {
        return <Redirect to="/" />;
      }
    } else if (auth.login.sending_success) {
      return (
        <React.Fragment>
          <Typography variant="h4">
            Sign In Email sent to {auth.login.email}
          </Typography>
          <Typography>
            Check your inbox for an email with a link to procceed with the
            login. If you have not verified your email and cannot find it please
            contact team@crwdnetwork.com.
          </Typography>
        </React.Fragment>
      );
    } else {
      const fromPathname = this.props.location.state
        ? this.props.location.state.from.pathname
        : null;
      //console.log("redirect", fromPathname);
      return (
        <Container>
          <Formik
            enableReinitialize={true}
            initialValues={{
              email: ""
            }}
            onSubmit={(values, actions) => {
              this.props.loginUser(values.email, fromPathname);
              actions.setSubmitting(false);
            }}
            validationSchema={Yup.object().shape({
              email: Yup.string()
                .email("Invalid email address")
                .required("Email is required!")
            })}
            render={props => (
              <form
                onSubmit={props.handleSubmit}
                className={classes.container}
                name="LoginForm"
              >
                <Typography variant="h4">Sign In</Typography>
                <TextField
                  type="email"
                  name="email"
                  label="Email"
                  className={classes.textField}
                  onChange={props.handleChange}
                  value={props.values.email}
                  required
                  onBlur={props.handleBlur}
                  error={typeof props.errors.email !== "undefined"}
                  helperText={
                    props.errors.email && props.touched.email
                      ? props.errors.email
                      : ""
                  }
                />

                <div className={classes.actionsContainer}>
                  {!auth.login.sending && (
                    <Button
                      type="submit"
                      name="submit"
                      color="primary"
                      variant="outlined"
                      className={(classes.button, "signInButton")}
                    >
                      Sign In
                    </Button>
                  )}
                  {auth.login.sending && (
                    <Spinner className={classes.spinner} />
                  )}
                  {auth.login.sending_error && (
                    <Typography className={classes.error}>
                      Connecting to server failed! Please retry.
                    </Typography>
                  )}
                </div>
              </form>
            )}
          />
        </Container>
      );
    }
  }
};
const mapStateToProps = state => {
  return {
    auth: state.auth
  };
};

const mapDispatchToProps = dispatch => {
  return {
    loginUser: (email, redirect) => dispatch(loginUser(email, redirect))
  };
};

const LoginRedux = connect(mapStateToProps, mapDispatchToProps)(Login);

export default withStyles(styles)(LoginRedux);
